export const BEGIN_SIGNIN = 'BEGIN_SIGNIN';
export const CANCEL_SIGNIN = 'CANCEL_SIGNIN';
export const BEGIN_JOIN = 'BEGIN_JOIN';
export const CANCEL_JOIN = 'CANCEL_JOIN';



// WEBPACK FOOTER //
// ./js/actions/Auth.js